import gql from 'graphql-tag'

export const CREATE_GROUP_STORY = gql`
  mutation createGroupStory($id: ID!, $storyAttributes: StoryAttributes!) {
    createGroupStory(id: $id, storyAttributes: $storyAttributes) {
      errors
    }
  }
`
